function scoreColor(score) {
  if (score >= 80) return "#10B981";
  if (score >= 60) return "#F59E0B";
  return "#EF4444";
}

export default function HealthGauge({ score, breakdown }) {
  const color = scoreColor(score);
  const dims = Object.entries(breakdown || {});
  return (
    <CustomerPanel className="p-ui-6" data-testid="health-report-gauge">
      <div className="font-mono text-[11px] uppercase tracking-[0.2em] text-slate-500">
        CRM Health Score
      </div>
      <div className="mt-3 flex items-end gap-2">
        <span className="font-mono text-6xl font-bold tracking-tighter text-slate-900" data-testid="health-score-value">
          {score}
        </span>
        <span className="mb-2 font-mono text-lg text-slate-400">/ 100</span>
      </div>
      <div className="mt-ui-4 h-2 w-full overflow-hidden rounded-full bg-slate-100">
        <div className="h-full rounded-full transition-all" style={{ width: `${score}%`, backgroundColor: color }} />
      </div>
      <div className="mt-6 space-y-3">
        {dims.map(([label, value]) => (
          <div key={label}>
            <div className="mb-1 flex items-center justify-between text-xs">
              <span className="text-slate-600">{label}</span>
              <span className="font-mono font-medium text-slate-900">{value}</span>
            </div>
            <div className="h-1.5 w-full overflow-hidden rounded-full bg-slate-100">
              <div className="h-full rounded-full" style={{ width: `${value}%`, backgroundColor: scoreColor(value) }} />
            </div>
          </div>
        ))}
      </div>
      <details className="mt-4 text-sm text-slate-600">
        <summary className="min-h-11 cursor-pointer py-3 font-medium text-slate-900">How this score works</summary>
        <p className="leading-6">This measures CRM data condition, not CleanIQ performance. Validation, completeness, deduplication and normalization contribute to a weighted score, not a plain average. Missing data can lower health before you choose an action. A change between scans does not by itself prove that CleanIQ caused it.</p>
      </details>
    </CustomerPanel>
  );
}
import { CustomerPanel } from "./customer/CustomerUI";
